import { render, staticRenderFns } from "./CompletedOrders.vue?vue&type=template&id=e88abd12"
import script from "../../script/orders/completedOrder.js?vue&type=script&lang=js&external"
export * from "../../script/orders/completedOrder.js?vue&type=script&lang=js&external"
import style0 from "../../less/orders/orders.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports